/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import api from 'services/api';
import { logEvent } from 'services/amplitude';
import { IEvents } from 'types';
import moment from 'moment';
import { Dispatch } from 'redux';
import Logger from 'components/common/helpers/devConsoleLog';
import { showSpinner, hideSpinner } from 'actions/spinner';
import {
  GET_EVENTS,
  CREATE_EVENT,
  GET_EVENT_ERRORS,
  DELETE_EVENT,
  GET_MERGE_EVENTS,
  SET_EVENT_VISITED,
} from './actionTypes';

export const clearEventsErrors = () => (dispatch: Dispatch): void => {
  dispatch({
    type: GET_EVENT_ERRORS,
    payload: [],
  });
};

export const createEvent = (
  eventData: IEvents,
  unitId: number,
  onSuccess?: () => void
) => async (dispatch: any): Promise<void> => {
  dispatch(showSpinner());
  try {
    const { data } = await api.post(`/units/${unitId}/events`, eventData);
    dispatch({
      type: CREATE_EVENT,
      payload: data,
    });

    dispatch(clearEventsErrors());
    if (onSuccess) {
      onSuccess();
    }
    // A.Starusiev TODO general error DTO
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    let errorMessage;
    if (typeof error?.response?.data?.message === 'string') {
      errorMessage = [error?.response?.data.message];
    } else {
      errorMessage = error?.response?.data?.message;
    }
    dispatch({
      type: GET_EVENT_ERRORS,
      payload: errorMessage,
    });
    Logger('createEvent error:', error);
  } finally {
    logEvent('CreateEvent');
    dispatch(hideSpinner());
  }
};

export const getEvents = (unit: number, from: string, to: string) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    const fromDate = moment(from).format('YYYY-MM-DD 00:00');
    const toDate = moment(to).format('YYYY-MM-DD 23:59');
    const { data } = await api.get(
      `/units/${unit}/events?from=${fromDate}&to=${toDate}`
    );
    dispatch({
      type: GET_EVENTS,
      payload: data,
    });
    dispatch({
      type: GET_MERGE_EVENTS,
      payload: data,
    });
  } catch (error) {
    Logger('getEvents error:', error);
  }
};

export const getMergeEvents = (
  unit: number,
  from: string,
  to: string
) => async (dispatch: Dispatch): Promise<void> => {
  try {
    const fromDate = moment(from).format('YYYY-MM-DD 00:00');
    const toDate = moment(to).format('YYYY-MM-DD 23:59');
    const { data } = await api.get(
      `/units/${unit}/events?from=${fromDate}&to=${toDate}`
    );
    dispatch({
      type: GET_MERGE_EVENTS,
      payload: data,
    });
  } catch (error) {
    Logger('getMergeEvents error:', error);
  }
};

export const editEvent = (
  unitId: number,
  eventId: number,
  requestData: IEvents,
  onSuccess?: () => void,
  repeatAction?: string
) => async (dispatch: Dispatch): Promise<void> => {
  dispatch(showSpinner());
  try {
    if (repeatAction) {
      await api.put(`/units/${unitId}/events/${eventId}`, {
        ...requestData,
        repeatAction,
      });
    } else {
      await api.put(`/units/${unitId}/events/${eventId}`, requestData);
    }
    if (onSuccess) {
      onSuccess();
    }
    // A.Starusiev TODO general error DTO
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    let errorMessage;
    if (typeof error?.response?.data?.message === 'string') {
      errorMessage = [error?.response?.data.message];
    } else {
      errorMessage = error?.response?.data?.message;
    }
    dispatch({
      type: GET_EVENT_ERRORS,
      payload: errorMessage,
    });
    Logger('editEvent error:', error);
  } finally {
    logEvent('EditEvent');
    dispatch(hideSpinner());
  }
};

export const setVisited = (unitId: number, eventId: number) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    await api.put(`/units/${unitId}/events/${eventId}/update-is-started`);

    dispatch({
      type: SET_EVENT_VISITED,
      payload: eventId,
    });
  } catch (error) {
    Logger('setVisited error:', error);
  }
};

export const deleteEvent = (
  unitId: number,
  eventId: number,
  repeatAction?: string
) => async (dispatch: Dispatch): Promise<void> => {
  dispatch(showSpinner());
  try {
    if (repeatAction) {
      await api.delete(`/units/${unitId}/events/${eventId}`, {
        data: { repeatAction },
      });
    } else {
      await api.delete(`/units/${unitId}/events/${eventId}`);
    }
    dispatch({
      type: DELETE_EVENT,
      payload: eventId,
    });
  } catch (error) {
    Logger('deleteEvent error:', error);
  } finally {
    dispatch(hideSpinner());
  }
};
